module.exports = __webpack_public_path__ + "img/whatsapp-logo.e1bc9ead.png";